import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { PERMISSIONS } from "app/utils/permissions";

const StrainOrBreedList = Loadable(lazy(() => import("./StrainOrBreedList")));
const StrainOrBreedForm = Loadable(lazy(() => import("./StrainOrBreedForm")));

const strainOrBreedRoutes = [
  {
    path: "/StrainOrBreed/StrainOrBreedList",
    element: <StrainOrBreedList />,
    permission: PERMISSIONS.StrainOrBreeds.Menu,
  },
  {
    path: "/StrainOrBreed/StrainOrBreedForm",
    element: <StrainOrBreedForm />,
  },
  {
    path: "/StrainOrBreed/StrainOrBreedForm/:strainOrBreedId",
    element: <StrainOrBreedForm />,
  },
];

export default strainOrBreedRoutes;
